<template>
  <div class="auction_view" v-if="loaded">
    <div class="title_box">
      <h1>
        {{ car_data["make"] }} {{ car_data["model"] }} {{ car_data["year"] }}
      </h1>
      <a
        v-bind:href="'https://www.copart.com/lot/' + car_data['lot_number']"
        v-if="car_data['auction_name'] == 'COPART'"
        target="_blank"
        class="auction_name"
        >{{ car_data["auction_name"] }}</a
      >
      <a v-if="car_data['auction_name'] == 'IAAI'" class="auction_name">{{
        car_data["auction_name"]
      }}</a>
      <p class="vin">{{ car_data["vin"] }}</p>
      <p class="lot">{{ car_data["lot_number"] }}</p>
      <div class="info-boxes">
        <div
          v-if="car_data['engine_type'] != null"
          class="info-box"
          v-for="box in car_data['engine_type'].split(',')"
        >
          {{ box }}
        </div>
        <div class="info-box" v-if="car_data['fuel'] != null">
          {{ car_data["fuel"].toUpperCase() }}
        </div>
        <div class="info-box" v-if="car_data['car_keys'] == 'yes'">
          <img
            src="../assets/icons/key.svg"
            class="icon"
            @click="selected.auction_name = ''"
          />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="images">
        <div class="main-image">
          <div class="image_slider">
            <transition-group name="fade" tag="div" v-if="loaded">
              <div v-for="i in [currentIndex]" :key="i">
                <img
                  :src="currentImg"
                  class="main_image"
                  @error="imageLoadOnError"
                />
              </div>
            </transition-group>

            <button class="prev image_button" @click="prev">
              <img src="../assets/icons/slider_arrow_right.svg" class="icon" />
            </button>

            <button class="next image_button" @click="next">
              <img src="../assets/icons/slider_arrow_left.svg" class="icon" />
            </button>
          </div>
        </div>
        <div class="other-images">
          <img
            v-for="(image, index) in car_data['car_photo']['photo']"
            :src="image"
            @click="currentIndex = index"
            alt=""
          />
        </div>
      </div>
      <div class="details">
        <div class="main-info">
          <div class="info_box">
            <p>Lot</p>
            <span>{{ car_data["lot_number"] }}</span>
          </div>
          <div class="info_box">
            <p>VIN</p>
            <span>{{ car_data["vin"] }}</span>
          </div>
          <div class="info_box">
            <p>Sprzedający</p>
            <span>{{ car_data["seller"] }}</span>
          </div>
          <div class="info_box">
            <p>Dokument</p>
            <span>{{ car_data["doc_type"] }}</span>
          </div>
        </div>
        <div class="condition">
          <span class="box-title">STAN POJAZDU</span>
          <div class="info_box">
            <p>Status</p>
            <span>{{ car_data["highlights"] }}</span>
          </div>
          <div class="info_box">
            <p>Glówne uszkodzenia</p>
            <span>{{ car_data["primary_damage"] }}</span>
          </div>

          <div class="info_box">
            <p>Pozostałe uszkodzenia</p>
            <span>{{ car_data["secondary_damage"] }}</span>
          </div>
          <div class="info_box">
            <p>Przebieg</p>
            <span
              >{{
                Math.round(
                  Number(car_data["odometer"]) * 1.6093
                ).toLocaleString()
              }}
              km ({{ Number(car_data["odometer"]).toLocaleString() }} mi)</span
            >
          </div>
          <div class="info_box">
            <p>Klucze</p>
            <span v-if="car_data['car_keys']">TAK</span>
            <span v-else>NIE</span>
          </div>
        </div>
        <div class="car-details">
          <span class="box-title">SZCZEGÓŁY POJAZDU</span>
          <div class="info_box">
            <p>Kolor</p>
            <span class="color">
              <div
                class="dott"
                :style="{ 'background-color': car_data['color'] }"
              ></div>
              {{ car_data["color"] }}</span
            >
          </div>
          <div class="info_box">
            <p>Silnik</p>
            <span>{{ car_data["engine_type"] }}</span>
          </div>
          <div class="info_box">
            <p>Napęd</p>
            <span>{{ String(car_data["drive"]).toUpperCase() }}</span>
          </div>
          <div class="info_box">
            <p>Paliwo</p>
            <span>{{ car_data["fuel"] }}</span>
          </div>
        </div>
      </div>
      <div class="calculator_box">
        <Calculator :car_data="car_data" />
      </div>
    </div>
  </div>
  <div v-else class="spinner_box">
    <img src="../assets/animation_ac.gif" class="spinner" />
  </div>
</template>


<script>
import axios from "axios";
import Calculator from "@/components/Calculator.vue";
import AuctionInfo from "@/components/AuctionInfo.vue";

export default {
  data() {
    return {
      car_data: {},
      timer: null,
      currentIndex: 0,
      loaded: false,
      no_tariff: false,
      requests_left: 0,
    };
  },
  components: {
    Calculator,
    AuctionInfo,
  },
  created() {
    this.getCarData();
  },
  methods: {
    imageLoadOnError(e) {
      e.target.src =
        "https://ralfvanveen.com/wp-content/uploads/2021/06/Placeholder-_-Glossary.svg";
    },
    async getCarData() {
      console.log(this.$route.params.id);
      var { data } = await axios.post(
        process.env.VUE_APP_API_HOST + "/get-car-lot/",
        {
          lot_number: this.$route.params.id,
        },
        {
          headers: {
            "X-API-Key": process.env.VUE_APP_API_KEY,
          },
        }
      );
      console.log(data);
      this.requests_left = data["api_request_left"];
      if (data["message"] == "No active tariff found.") {
        this.no_tariff = true;
      } else {
        this.car_data = data["result"][0];
        console.log(this.car_data);
        this.loaded = true;
      }
    },
    next: function () {
      this.currentIndex += 1;
    },
    prev: function () {
      this.currentIndex -= 1;
    },
  },
  computed: {
    currentImg: function () {
      return this.car_data["car_photo"]["photo"][
        Math.abs(this.currentIndex) % this.car_data["car_photo"]["photo"].length
      ];
    },
  },
};
</script>

<style scoped>
.spinner {
  height: 100px;
  margin: auto;
  display: block;
}
.auction_view {
  padding: 20px;
  background-color: #edf2f7;
}
.title_box {
  background-color: white;
  padding: 10px 30px;
  display: flex;
  align-items: center;
  gap: 15px;
}
.title_box h1 {
  color: #2e3192;
  font-size: 30px;
}
.auction_name {
  display: inline-block;
  font-family: "bicyclette";
  font-size: 12px;
  color: white;
  background-color: #be1e2d;
  margin: 0;
  bottom: 0;
  padding: 2px 3px;
}
.vin,
.lot {
  color: #011f68;
  font-weight: 100;
  font-size: 14px;
}
.info-boxes {
  display: flex;
  gap: 15px;
}
.info-box {
  padding: 8px;
  font-size: 14px;
  font-weight: bold;
  color: #011f68;
  background: #eff2f7;
}
.content {
  display: grid;
  gap: 15px;
  margin-top: 20px;
  grid-template-columns: 3fr 2fr 2fr;
}
.images,
.details,
.calculator_box {
  height: fit-content;
}

.images {
  background-color: white;
  padding: 20px;
}

.main-image img {
  width: 100%;
  margin: auto;
  display: block;
}
.image_slider {
  position: relative;
  margin: auto;
}
.image_button {
  font-size: 18px;

  background-color: rgba(180, 179, 179, 0.896);
  border: none;
  background-color: transparent;
  padding: 0;
}

.prev,
.next {
  cursor: pointer;
  position: absolute;
  top: 50%;
  width: auto;
  padding: 16px;
  margin-top: -22px;
  color: white;
  font-weight: bold;
  font-size: 18px;
  transition: 0.6s ease;
  border-radius: 0 3px 3px 0;
  user-select: none;
}
.auction_view .image_button {
  background-color: transparent;
  padding: 0;
}

.auction_view .next:hover,
.auction_view .prev:hover {
  background-color: transparent;
}
.auction_view .image_button.prev {
  left: -18px;
}
.auction_view .image_button.next {
  right: -18px;
}
/* On hover, add a black background color with a little bit see-through */
.auction_view .next:hover,
.auction_view .prev:hover {
  background-color: transparent;
}

.other-images {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 30px;
}
.other-images img {
  flex-grow: 1;
  min-width: 0px;
  max-width: 150px;
  width: 100%;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.main-info,
.car-details,
.condition {
  background-color: white;
  padding: 15px;
}

.condition {
  display: flex;
  flex-direction: column;
  height: 255px;
}

.main-info {
  height: 180px;
}

.car-details {
  display: flex;
  flex-direction: column;
  height: 215px;
}
.info_box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 5px;
  border-bottom: 1.3px solid #edf2f7;
}
.info_box p {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: #2e3192;
}
.info_box span {
  font-size: 16px;
  font-weight: thin;
  color: #2e3192;
}
.condition .box-title {
  margin-bottom: 20px;
  font-size: 13px;
  color: #2e3192;
}
.car-details .box-title {
  margin-bottom: 20px;
  font-size: 13px;
  color: #2e3192;
}
.dott {
  width: 12px;
  height: 12px;
  border-radius: 6px;
}
.color {
  display: flex;
  align-items: center;
  gap: 8px;
}
@media only screen and (max-width: 1200px) {
  .content {
    grid-template-columns: 3fr 2fr;
  }
}
@media only screen and (max-width: 800px) {
  .content {
    grid-template-columns: 1fr;
  }
  .title_box {
    flex-wrap: wrap;
  }
  .title_box h1 {
    margin: 0;
    margin-top: 10px;
  }
  .other-images {
    display: none;
  }
  .auction_view {
    padding: 0;
  }
  .info-boxes {
    display: none;
  }
  .title_box h1 {
    width: 100%;
  }
}
</style>